import { render, staticRenderFns } from "./LinkCopyInput.vue?vue&type=template&id=087a33b0&scoped=true"
import script from "./LinkCopyInput.vue?vue&type=script&lang=js"
export * from "./LinkCopyInput.vue?vue&type=script&lang=js"
import style0 from "./LinkCopyInput.vue?vue&type=style&index=0&id=087a33b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "087a33b0",
  null
  
)

export default component.exports